import RoleApi from '../../../api/src/role/api/RoleApi'
import {message} from "ant-design-vue";

const roleApi = new RoleApi();

const state = {
    majorList: []
}

const mutations = {
    addMajorList(state, data) {
        state.majorList = data || []
    },
}

const actions = {
    // 角色列表
    allRole: async ({commit, state}) => {
        let result = await roleApi.findAll();
        return result || []
    },
    // 添加专业
    addMajor: ({commit, state}, query) => {
        console.log(query)
        return new Promise((resolve, reject) => {
            roleApi.add(query.body).then(res => {
                resolve(res)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    // 删除课程
    delRole: ({commit, state}, id) => {
        return new Promise((resolve, reject) => {
            roleApi.remove(id).then(res => {
                resolve(res)
            }).catch(err => {
                console.log(err)
            })
        })
    },
    // 修改课程
    editMajor: ({commit, state}, query) => {
        return new Promise((resolve, reject) => {
            roleApi.update(query.id, query.body).then(res => {
                resolve(res)
            }).catch(err => {
                this.$message.error(err.message)
                console.log(err)
            })
        })
    }
}

export default {
    // namespaced: true,
    state,
    actions,
    mutations
}